export default "__VITE_ASSET__BZFJB3wN__"